import PdfContainer from '@/app/modules/pdf/containers/pdf-container.vue';
import ConfirmModal from '@/app/modules/toolkit/common/components/confirm-modal/confirm-modal.vue';
import ReviewItem from '@/app/modules/toolkit/common/components/review-item/review-item.vue';
import invStrat from '@/app/mixins/toolkit/invStrat/invStrat';
import { types } from '@/app/filters/filters';

export default {
  name: 'inv-strat-review',
  mixins: [invStrat],
  components: {
    PdfContainer,
    ConfirmModal,
    ReviewItem,
  },
  data: () => ({
    loadingComplete: false,
    loadingExit: false,
    showConfirmModal: false,
  }),
  computed: {
    canEdit() {
      const canEditFund = this.$store.getters['fund/canEditActiveFund'] || false;
      const appPermissions = this.$store.getters['account/getAppPermissions'] || [];
      const toolkitAppPermission = appPermissions.filter(app => app.appName === 'TOOLKIT')[0];
      return toolkitAppPermission.permission === 'OWNER' && canEditFund;
    },
    isComplete() {
      return this.$store.getters['toolkit/getItem'].status === 'COMPLETE';
    },
    fund() {
      return this.$store.getters['fund/getFund'];
    },
    invStrat() {
      return this.$store.getters['toolkit/getItem'];
    },
    invStratMembers() {
      return this.invStrat.data.members;
    },
    isInvStratMembersAdditionalInfo() {
      if (this.invStrat.data.memberInfo === null) {
        return false;
      }
      return true;
    },
    invStratMembersAdditionalInfo() {
      return (member) => {
        const keys = Object.keys(member.additionalInfo);
        return keys.flatMap(key => ({
          key: key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()),
          value: member.additionalInfo[key],
        }));
      };
    },
    objective() {
      return this.invStrat.data.objective.statement();
    },
    assets() {
      return this.invStrat.data.assets;
    },
    diversified() {
      return this.invStrat.data.diversified || {};
    },
    insurance() {
      return this.invStrat.data.insurance;
    },
    borrowing() {
      return this.invStrat.data.borrowing.toString();
    },
  },
  methods: {
    rangeStyle(asset) {
      return {
        left: `${asset.min}%`,
        width: `${asset.max - asset.min}%`,
      };
    },
    clearStrat() {
      this.$store.dispatch('resetFund');
      this.$store.dispatch('clearItem');
    },
    saveStrat(complete) {
      return this.$store.dispatch('toolkit/saveItem', complete);
    },
    handleSaveAndNew() {
      this.loadingComplete = true;
      this.showConfirmModal = false;
      this.saveStrat(true)
        .then(() => {
          this.$mixpanel.track('Toolkit Item', {
            uuid: this.invStrat.uuid,
            action: 'Completed',
            status: types(this.invStrat.status),
            type: this.invStrat.type,
          });
          if (this.canEdit) {
            this.$router.push('/toolkit/investment-strategy/dashboard');
          } else {
            this.$router.push('/');
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSaveAndExit() {
      this.loadingExit = true;
      this.$mixpanel.track('Toolkit Item', {
        uuid: this.invStrat.uuid,
        action: 'Exit',
        status: types(this.invStrat.status),
        type: this.invStrat.type,
      });
      if (this.canEdit) {
        this.$router.push('/toolkit/investment-strategy/dashboard');
      } else {
        this.$router.push('/');
      }
    },
  },
};
